module.exports = __webpack_public_path__ + "img/16_peaceJusticeAndStrongInstitutions.1ee982b0.png";